var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        directives: [{ name: "responsive", rawName: "v-responsive" }],
        staticClass: "bar no-border",
      },
      [
        _vm.someAdded
          ? _c("div", { class: _vm.$style.leftControls }, [
              _vm.addedUsers.length === 1
                ? _c(
                    "button",
                    {
                      staticClass: "button dark responsive",
                      on: { click: _vm.manageOneLink },
                    },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("link"),
                      ]),
                      _vm._v(" Manage Link "),
                      _c(
                        "div",
                        {
                          staticClass: "rbTooltip simple",
                          attrs: { tooltip: "placement:end-middle" },
                        },
                        [_vm._v(" Manage Link ")]
                      ),
                    ]
                  )
                : _vm._e(),
              _c(
                "button",
                {
                  staticClass: "button dark responsive",
                  on: { click: _vm.resend },
                },
                [
                  _c("i", { staticClass: "material-icons" }, [_vm._v("email")]),
                  _vm._v(
                    " Send Link to User" +
                      _vm._s(_vm.addedUsers.length > 1 ? "s" : "") +
                      " "
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "rbTooltip simple",
                      attrs: { tooltip: "placement:end-middle" },
                    },
                    [
                      _vm._v(
                        " Send Link to User" +
                          _vm._s(_vm.addedUsers.length > 1 ? "s" : "") +
                          " "
                      ),
                    ]
                  ),
                ]
              ),
              _vm.addedUsers.length === 1
                ? _c(
                    "button",
                    {
                      staticClass: "button dark responsive",
                      on: { click: _vm.edit },
                    },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("edit"),
                      ]),
                      _vm._v(" Edit User "),
                      _c(
                        "div",
                        {
                          staticClass: "rbTooltip simple",
                          attrs: { tooltip: "placement:end-middle" },
                        },
                        [_vm._v(" Edit User ")]
                      ),
                    ]
                  )
                : _vm._e(),
              _c(
                "button",
                {
                  staticClass: "button dark responsive",
                  on: { click: _vm.dropMany },
                },
                [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("delete"),
                  ]),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.addedUsers.length > 1
                          ? "Delete Users"
                          : "Delete User"
                      ) +
                      " "
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "rbTooltip simple",
                      attrs: { tooltip: "placement:end-middle" },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.addedUsers.length > 1
                              ? "Delete Users"
                              : "Delete User"
                          ) +
                          " "
                      ),
                    ]
                  ),
                ]
              ),
              _c(
                "button",
                {
                  staticClass: "button dark responsive",
                  on: { click: _vm.assignCategory },
                },
                [
                  _c("i", { staticClass: "material-icons" }, [_vm._v("face")]),
                  _vm._v(" Assign Category "),
                  _c(
                    "div",
                    {
                      staticClass: "rbTooltip simple",
                      attrs: { tooltip: "placement:end-middle" },
                    },
                    [_vm._v(" Assign Category ")]
                  ),
                ]
              ),
            ])
          : _vm._e(),
        _c(
          "div",
          { class: _vm.$style.controls },
          [
            _c(
              "hd-select",
              {
                attrs: { align: "right", dark: true, items: _vm.groupers },
                model: {
                  value: _vm.groupBy,
                  callback: function ($$v) {
                    _vm.groupBy = $$v
                  },
                  expression: "groupBy",
                },
              },
              [
                _c(
                  "i",
                  {
                    staticClass: "material-icons",
                    attrs: { slot: "icon" },
                    slot: "icon",
                  },
                  [_vm._v("calendar_view_day")]
                ),
                _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                  _vm._v("Group By"),
                ]),
              ]
            ),
            _vm.filters.length > 0
              ? _c(
                  "hd-select",
                  {
                    attrs: { align: "right", dark: true, items: _vm.filters },
                    model: {
                      value: _vm.filterBy,
                      callback: function ($$v) {
                        _vm.filterBy = $$v
                      },
                      expression: "filterBy",
                    },
                  },
                  [
                    _c(
                      "i",
                      {
                        staticClass: "material-icons",
                        attrs: { slot: "icon" },
                        slot: "icon",
                      },
                      [_vm._v("filter_list")]
                    ),
                    _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                      _vm._v("Filter By"),
                    ]),
                  ]
                )
              : _vm._e(),
            _c(
              "hd-select",
              {
                attrs: {
                  align: "right",
                  dark: true,
                  sorter: true,
                  items: _vm.sorters,
                },
                model: {
                  value: _vm.sortBy,
                  callback: function ($$v) {
                    _vm.sortBy = $$v
                  },
                  expression: "sortBy",
                },
              },
              [
                _c(
                  "i",
                  {
                    staticClass: "material-icons",
                    attrs: { slot: "icon" },
                    slot: "icon",
                  },
                  [_vm._v("sort")]
                ),
                _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                  _vm._v("Sort By"),
                ]),
              ]
            ),
            _c("div", { class: _vm.$style.verticalSeparator }),
            _c(
              "button",
              {
                staticClass: "button dark responsive",
                on: { click: _vm.upload },
              },
              [
                _c("i", { staticClass: "material-icons" }, [
                  _vm._v("group_add"),
                ]),
                _vm._v(" Upload Users "),
                _c(
                  "div",
                  {
                    staticClass: "rbTooltip simple",
                    attrs: { tooltip: "placement:end-middle" },
                  },
                  [_vm._v(" Upload Users ")]
                ),
              ]
            ),
            _c(
              "button",
              {
                staticClass: "button dark cta responsive",
                on: { click: _vm.create },
              },
              [
                _c("i", { staticClass: "material-icons" }, [
                  _vm._v("person_add"),
                ]),
                _vm._v(" Add User "),
                _c(
                  "div",
                  {
                    staticClass: "rbTooltip simple",
                    attrs: { tooltip: "placement:end-middle" },
                  },
                  [_vm._v(" Add User ")]
                ),
              ]
            ),
            _c(
              "button",
              {
                staticClass: "button dark icon-only",
                on: { click: _vm.editColumns },
              },
              [
                _c("i", { staticClass: "material-icons" }, [
                  _vm._v("settings"),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "rbTooltip simple",
                    attrs: { tooltip: "placement:end-middle" },
                  },
                  [_vm._v(" Organise Table Columns ")]
                ),
              ]
            ),
          ],
          1
        ),
      ]
    ),
    _c(
      "div",
      {
        staticClass: "manage-table",
        class: {
          [_vm.$style.table]: true,
          [_vm.$style.fullTable]: _vm.users && _vm.users.length > 0,
        },
      },
      [
        _c(
          "div",
          { staticClass: "row tableHead" },
          [
            _c("div", { staticClass: "cell head checkboxHead" }, [
              _c(
                "span",
                { staticClass: "material-icons", on: { click: _vm.selectAll } },
                [
                  _vm._v(
                    _vm._s(
                      _vm.allAdded
                        ? "check_box"
                        : _vm.someAdded
                        ? "indeterminate_check_box"
                        : "check_box_outline_blank"
                    )
                  ),
                ]
              ),
            ]),
            _vm._l(_vm.columns, function (column) {
              return _c("div", { key: column, staticClass: "cell head" }, [
                _vm._v(" " + _vm._s(_vm.getColumn(column).text) + " "),
              ])
            }),
            _c(
              "div",
              {
                staticClass: "cell head cell-xs",
                staticStyle: { "min-width": "50px", "max-width": "50px" },
              },
              [_vm._v(" Actions ")]
            ),
          ],
          2
        ),
        _vm._l(_vm.sortedAndGrouped, function (group) {
          return [
            !_vm.loading
              ? [
                  group.key !== null
                    ? _c("div", { key: group.key, staticClass: "grouper" }, [
                        _vm.groupBy === "category"
                          ? _c("span", [
                              _vm._v(
                                _vm._s(
                                  (_vm.getView(group.key) &&
                                    _vm.getView(group.key).name) ||
                                    "Not Assigned"
                                )
                              ),
                            ])
                          : _c("span", [_vm._v(_vm._s(group.key || "___"))]),
                      ])
                    : _vm._e(),
                  _vm._l(group.items, function (item) {
                    return _c("table-row", {
                      key: item.id,
                      class: _vm.$style.table,
                      attrs: {
                        row: item,
                        columns: _vm.columns,
                        added: _vm.added(item),
                        "all-columns": _vm.allColumns,
                        views: _vm.views,
                      },
                      on: {
                        add: _vm.add,
                        remove: _vm.remove,
                        drop: _vm.drop,
                        link: _vm.manageLink,
                        assignView: _vm.assignView,
                      },
                    })
                  }),
                ]
              : _vm._e(),
          ]
        }),
      ],
      2
    ),
    _vm.empty
      ? _c(
          "div",
          { class: _vm.$style.empty },
          [
            _vm.loading
              ? _c(
                  "div",
                  {
                    staticClass: "layout-column flex-center",
                    class: _vm.$style.loader,
                  },
                  [
                    _c("rbv-loading", {
                      attrs: { label: "Loading, please wait..." },
                    }),
                  ],
                  1
                )
              : [
                  _c("div", { class: _vm.$style.emptyTitle }, [
                    _vm._v("Nothing to see here (:"),
                  ]),
                  _c("div", { class: _vm.$style.emptySubTitle }, [
                    _vm._v(
                      "You have not yet added any users to your hotel directory"
                    ),
                  ]),
                  _c("div", [
                    _c(
                      "button",
                      { staticClass: "button dark", on: { click: _vm.upload } },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("group_add"),
                        ]),
                        _vm._v(" Upload Users "),
                      ]
                    ),
                  ]),
                ],
          ],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }